import { type AppOpenerAdapter } from './AppOpenerAdapter';
import { usePlatform } from '../PlatformContext';

export const useAppOpener = (): AppOpenerAdapter => usePlatform().appOpener;
